// 分销商价格管理数据
// 由于商品中心的供销商品也需要此数据计算价格，所以放在vuex管理

// 一些异步获取的字典数据
import { getDistributionPrice } from "@/api/supplier"

const distributorPrice = {
  state: () => ({
    data: null,
  }),
  mutations: {
    setData (state, data) {
      state.data = data
    },
  },
  actions: {
    getDistributionPrice({commit}) {
      return getDistributionPrice().then(({ data = {} }) => {
          if (data?.distributionPriceSettings) {
              data.distributionPriceSettings = JSON.parse(data.distributionPriceSettings)
          }
          commit("setData", data)
          return true;
      }).catch(err => console.log('actions-getDistributionPrice-error!###', err))
    },
    clearDistributionPrice({commit}) {
      commit("setData", [])
    }
  },
  getters: {
    distributorPrice(state) {
        return state.data
    },
    distributionRules(state) {
      if(!state.data) return null
      const {
        level1DistributorPrice, level1SetType, 
        level2DistributorPrice, level2SetType, 
        level3DistributorPrice, level3SetType, 
        level4DistributorPrice, level4SetType,
        level5DistributorPrice, level5SetType,
        priceFixType
      } = state.data
      return {
        level1DistributorPrice,
        level1SetType,
        level2DistributorPrice,
        level2SetType,
        level3DistributorPrice,
        level3SetType,
        level4DistributorPrice,
        level4SetType,
        level5DistributorPrice,
        level5SetType,
        priceFixType
      }
    }
  }
}

export default distributorPrice

